import { useSearchParams } from 'react-router-dom';
import UrlEncodeDecode from './urlEncodeDecode';

export default function useTxSearchParams() {
    const [queryParams, setQueryParams] = useSearchParams();

    const decodeState = () => {
        const state = queryParams.get(UrlEncodeDecode.STATE_NAME);
        if(!state) {
            return new URLSearchParams()
        }
        const decoded = UrlEncodeDecode.decode(state);
        return new URLSearchParams(decoded);
    }


    const customGetFunction = (key) => {
        const urlSearchParams = decodeState();
        const value = urlSearchParams.get(key);
        return value;
    }

    const customHasFunction = (key) => {
        const urlSearchParams = decodeState();
        const value = urlSearchParams.has(key);
        return value;
    }

    const customSetFunction = (key, setValue) => {
        const urlSearchParams = decodeState();
        urlSearchParams.set(key, setValue)
        const encoded =  UrlEncodeDecode.encode(urlSearchParams.toString())
         
        queryParams.set(UrlEncodeDecode.STATE_NAME, encoded);
    }

    const customDeleteFunction = (key, deleteValue) => {
        const urlSearchParams = decodeState();
        if(deleteValue) {
            urlSearchParams.delete(key, deleteValue)
        } else {
            urlSearchParams.delete(key)
        }
        const encoded =  UrlEncodeDecode.encode(urlSearchParams.toString())
         
        queryParams.set(UrlEncodeDecode.STATE_NAME, encoded);
    }

    const customSearchParams = {
        ...queryParams,
        get: customGetFunction,
        has: customHasFunction,
        set: customSetFunction,
        delete: customDeleteFunction,
      };

      const setCustomSearchParams = () => {
        setQueryParams(queryParams)
      }

    return [customSearchParams, setCustomSearchParams];
}